// auth
// wrapper around firebase auth module

// type Handler = any
// type Provider = 'Google' | 'Facebook' | 'Anonymous' | 'Email'
// type Method = 'in' | 'up'
// type Info = { email: string, password: string, confirmPassword: string | undefined }


export default class Auth {

  constructor(firebase) {
    this.firebase = firebase
    this.auth = firebase.auth()
  }

  // handler is a function that takes a userToken object
  addListener(handler) {
    console.log('auth addlistener called - register signin/out handler', handler)
    return this.auth.onAuthStateChanged(handler)
  }

  // handleAuthStateChange(userToken) {
  // }

  // convert an auth user token to our user object
  getUserFromToken(userToken) {
    if (!userToken) return null
    const user = {}
    user.id = userToken.uid // a 28 alphanum char id, from firebase auth
    user.name = userToken.displayName
    user.email = userToken.email
    user.emailVerified = userToken.emailVerified
    user.isAnonymous = userToken.isAnonymous
    user.photoURL = userToken.photoURL
    return user
  }

  signOut() {
    this.auth.signOut()
  }

  // sign in or up using various providers
  // provider can be 'Google', 'Email', ...
  // inOrUp can be 'in', 'up'
  // returns userToken object with .uid - or null
  async signInUp(params) {
    console.log('signinup', params)
    const { provider, inOrUp, email, password, confirmPassword } = params
    let result = null
    try {
      switch (provider) {
        case 'Google': {
          const authProvider = new this.firebase.auth.GoogleAuthProvider()
          authProvider.addScope('profile')
          authProvider.addScope('email')
          result = await this.auth.signInWithPopup(authProvider)
          // result = await firebase.auth().signInWithRedirect(authProvider)
          break
        }
        case 'Facebook': {
          const authProvider = new this.firebase.auth.FacebookAuthProvider()
          authProvider.addScope('profile')
          authProvider.addScope('email')
          result = await this.auth.signInWithPopup(authProvider)
          break
        }
        // case 'Anonymous': {
        //   result = await this.auth.signInAnonymously()
        //   break
        // }
        case 'Email': {
          if (inOrUp === 'in') {
            result = await this.auth.signInWithEmailAndPassword(email, password)
          } else {
            if (password !== confirmPassword) {
              //. use ui callback - better for testing etc
              alert("Passwords must match!")
              return null
            }
            result = await this.auth.createUserWithEmailAndPassword(email, password)
          }
          break
        }
        default: {
          throw new Error("Unknown signin provider")
        }
      }
    } catch (error) {
      // error has { code, message, email, credential }
      // alert(JSON.stringify(error))
      // alert(error.message) // can be email invalid, password too short, etc
      // alert(error.message) // can be invalid password, etc
      console.error(error)
      //. use ui callback
      //. error The email address is already in use by another account.
      alert(error.message)
      return null
    }
    // console.log(result)
    // return result
    // result has { accessToken, user }
    // the user object has all kinds of info in it, including .uid, a unique user id
    const userToken = result.user
    return userToken
  }

}
